import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthConfig, OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  oauthService = inject(OAuthService);

  empNumber = '';
  isAuthenticated = signal(false);
  isAuthError = signal(false);

  authRetries = 0;

  readonly authConfig: AuthConfig = {
    issuer: environment.adfsAuthority,
    redirectUri: `${window.location.origin}/redirect`,
    clientId: environment.clientId,
    scope: 'openid offline_access profile',
    responseType: 'code',
    showDebugInformation: true,
    strictDiscoveryDocumentValidation: false,
    skipIssuerCheck: true,
  };

  init(): void {
    this.oauthService.configure(this.authConfig);
    this.oauthService.setupAutomaticSilentRefresh();
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService.events.subscribe((event: OAuthEvent) => {
      console.log('Auth event: ', event.type);

      if (event.type === 'invalid_nonce_in_state') {
        this.authenticate();
      }
    });

    this.authenticate();
  }

  // Same as authenticate, but zeroes the retry count.
  manualRetry(): void {
    this.authRetries = 0;
    this.authenticate();
  }

  authenticate(): void {
    this.authRetries++;
    console.log(`Auth tries: ${this.authRetries}`);

    // Prevent an infinite loop of retries.
    if (this.authRetries < 4) {
      this.oauthService
        .loadDiscoveryDocumentAndTryLogin()
        .then(() => {
          console.log(
            'Is authenticated',
            this.oauthService.hasValidAccessToken(),
          );
          this.isAuthenticated.set(this.oauthService.hasValidAccessToken());

          if (!this.oauthService.hasValidAccessToken()) {
            const path = window.location.pathname;
            console.log('Requested path:', path);
            this.oauthService.initCodeFlow(path);
          } else {
            this.isAuthError.set(false);
            this.authRetries = 0;
            const claims = this.oauthService.getIdentityClaims();
            this.empNumber = claims['apaempid'];
          }
        })
        .catch((err) => {
          console.log('Auth error', err);
          this.oauthService.initCodeFlow();
        });
    } else {
      this.isAuthError.set(true);
    }
  }
}
